import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { SiaCheckBoxComponent, SiaTextBoxComponent } from '@sia/inputs';
import {
  AutofocusDirective,
  SiaComponentConfigPerspectives,
  SiaTranslatePipe,
} from '@sia/shared';

@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: 'save-grid-view-dialog.component.html',
  styleUrl: 'save-grid-view-dialog.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SiaTextBoxComponent,
    SiaCheckBoxComponent,
    MatButton,
    AutofocusDirective,
    MatDialogContent,
    MatIcon,
    MatDialogTitle,
    MatDialogActions,
    SiaTranslatePipe,
  ],
})
export class SaveGridViewDialogComponent {
  readonly dialogRef =
    inject<MatDialogRef<SaveGridViewDialogComponent>>(MatDialogRef);
  readonly perspective = signal<SiaComponentConfigPerspectives>(
    inject(MAT_DIALOG_DATA),
  );
  readonly goToInfo = signal(false);
  readonly isDefault = computed(() => this.perspective().defaultMode === 'A');

  save() {
    const perspective = this.perspective();
    this.dialogRef.close({
      ...perspective,
      defaultMode: this.isDefault() ? 'A' : 'O',
    });
  }
  close() {
    this.dialogRef.close();
  }
  updatePerspective() {
    this.goToInfo.set(true);
  }
  createNewPerspective() {
    this.goToInfo.set(true);
    this.perspective.update((perspective) => ({
      ...perspective,
      id: undefined,
    }));
  }

  onDescriptionChange(value: string) {
    this.perspective.update((perspective) => ({
      ...perspective,
      description: value,
    }));
  }

  onDefaultChange(value: boolean) {
    this.perspective.update((perspective) => ({
      ...perspective,
      defaultMode: value ? 'A' : 'O',
    }));
  }
}
